'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SocialProviderButton = function (_Component) {
  _inherits(SocialProviderButton, _Component);

  function SocialProviderButton() {
    _classCallCheck(this, SocialProviderButton);

    return _possibleConstructorReturn(this, (SocialProviderButton.__proto__ || Object.getPrototypeOf(SocialProviderButton)).apply(this, arguments));
  }

  _createClass(SocialProviderButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          provider = _props.provider,
          text = _props.text,
          className = _props.className,
          otherProps = _objectWithoutProperties(_props, ['provider', 'text', 'className']);

      return _react2.default.createElement(
        'button',
        _extends({
          className: 'SocialProviderButton btn ' + provider + ' ' + className
        }, otherProps),
        text
      );
    }
  }]);

  return SocialProviderButton;
}(_react.Component);

SocialProviderButton.propTypes = {
  provider: _propTypes2.default.oneOf(['facebook', 'twitter', 'linkedin', 'google']).isRequired,
  className: _propTypes2.default.string,
  text: _propTypes2.default.string.isRequired
};

SocialProviderButton.defaultProps = {
  className: ''
};

exports.default = SocialProviderButton;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/SocialProviderButton.js
// module id = 102
// module chunks = 0